export const signupReportHelper = {
	STORAGE_KEY_PREFIX: 'SIGNUP_PAGE_COME_FROM',
	/**
	 * @param {String} from 从哪个页面跳转过来的
	 */
	markComeFromAnotherPage: function(from) {
		sessionStorage.setItem(
			this.STORAGE_KEY_PREFIX,
			JSON.stringify({ from: from, signupUrl: location.href }),
		)
	},
	getSignupSession: function() {
		const sessionStorageKey = this.STORAGE_KEY_PREFIX
		let info
		try {
			var str = sessionStorage.getItem(sessionStorageKey)
			info = JSON.parse(str)
		} catch (error) {
			return
		}
		return info
	},
	// 如果页面是从注册页面跳转过来的。则上报事件
	reportFromSignupOnce() {
		const info = this.getSignupSession()
		if (Boolean(info) && info.signupUrl) {
			// 上报一次事件
			if (!info.reported) {
				teaAnalyticsEvent('signup_web_uuid', {
					from: info.from || '',
				})
				this.saveSession({ reported: true })
			}
		}
	},
	saveSession(info) {
		sessionStorage.setItem(this.STORAGE_KEY_PREFIX, JSON.stringify(info))
	},
}
